import {Box, Flex, Link as ChakraLink} from '@chakra-ui/react'
import Link from '../link'
import {CUSTOMER_SERVICE_HREF} from '../../constants'
import {QuestionMarkIcon} from '../icons'
import {FormattedMessage} from 'react-intl'
import LocaleSelector from '../locale-selector'
import React from 'react'
import useCmsContent from '../cms-content/hooks/use-cms-content'
import {useGetHeaderLinks} from '../../utils/utils'
import useMultiSite from '../../hooks/use-multi-site'

/**
 * Renders application links on mobile drawer bellow the dynamic portion
 */
const DrawerApplicationLinks = () => {
    const {buildUrl} = useMultiSite()

    const {data: headerLinksTemplate} = useCmsContent('header-links')
    const headerLinks = useGetHeaderLinks(headerLinksTemplate)

    return (
        <Flex
            flexDirection="column"
            alignItems="flex-start"
            gap={2}
            padding={4}
            borderColor="stokkeGray.mid"
        >
            <Box padding={2}>
                <Link to={CUSTOMER_SERVICE_HREF} size="sm">
                    <QuestionMarkIcon boxSize={4} marginInlineEnd={2} />
                    <FormattedMessage id="global.help" defaultMessage="Help" />
                </Link>
            </Box>
            {headerLinks?.map((item, index) => {
                const svg = item.setupimage?.image ? window.atob(item.setupimage?.image) : null
                return (
                    <Box padding={2} key={'drawer-link-' + index}>
                        <ChakraLink
                            size="sm"
                            href={item.type === 'Link' ? `${buildUrl(item.link)}` : item.link}
                            display="flex"
                            alignItems="center"
                            _hover={{
                                path: {
                                    stroke: 'white',
                                    transition: '.5s'
                                }
                            }}
                        >
                            {!!svg && (
                                <Box
                                    dangerouslySetInnerHTML={{__html: svg}}
                                    paddingRight={1.5}
                                ></Box>
                            )}
                            {item.label}
                        </ChakraLink>
                    </Box>
                )
            })}
            <Box padding={2}>
                <LocaleSelector />
            </Box>
        </Flex>
    )
}

export default DrawerApplicationLinks
